import { createSlice } from '@reduxjs/toolkit';

// slice
const permissionsSlice = createSlice({
    name: 'permissions',
    initialState: {
        accessLevels: []
    },
    reducers: {
        systemPermissionsReceived: (state, action) => {
            return {
                ...state,
                ...action.payload
            };
        },
        setAccessLevels(state, action) {
            state.accessLevels = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase('systemPermissionsReceived.Pending', (state) => {
                console.log('Fetching system permissions...');
                return state;
            })
            .addCase('systemPermissionsReceived.Fullfilled', (state, action) => {
                return {
                    ...state,
                    ...action.payload
                };
            })
            .addCase('systemPermissionsReceived.Rejected', (state, action) => {
                console.error('Failed to fetch system permissions:', action.error);
            });
    }
});

export const { systemPermissionsReceived, setAccessLevels } = permissionsSlice.actions;
export default permissionsSlice.reducer;